export const FORGOT_PASSWORD_URL =
  process.env.REACT_APP_FORGOT_PASSWORD_URL ||
  'http://localhost:4000/auth/forgot-password'
